import Log from "@/api/error/Log";
import _ from "lodash";
import * as mapStackTrace from "sourcemapped-stacktrace";

export function debug (data)
{
	if (window.console)
	{
		console.log(data);
	}
}

export async function error (data)
{
	if (window.console)
	{
		console.error(data);
	}

	const sendToServer = async logData =>
	{
		if (!_.isEmpty(logData))
		{
			await new Log()
				.setUrl(location.href)
				.setLogData(logData)
				.call();
		}
	};

	let logData = {};

	if (data?.message)
	{
		logData.message = data.message;
	}

	if (data?.stack)
	{
		mapStackTrace.mapStackTrace(data.stack, mappedStack =>
		{
			logData.stack = mappedStack.join("\n");

			sendToServer(logData);
		});
	}
	else
	{
		await sendToServer(logData);
	}
}
